export default {"src":"/_next/static/media/0x3355df6d4c9c3035724fd0e3914de96a5a83aaf4.6f7cbaef.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};